import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { ShopDotsWidget } from 'widgets/shopDots/ui/ShopDotsWidget';

export const ShopDotsPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Торговые точки'));
    dispatch(setHeaderAction('create'));
    dispatch(setActionBtnTitle('Создать точку'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <ShopDotsWidget />;
};
